import _ from "lodash";
import { useEffect, useLayoutEffect, useRef, useState, createElement } from "react";
import { useLang } from "../zustand/store";

export default function TagBox(props) {
    const {
        style = {},
        className = "",
        list = []
    } = props;

    const { getLang, LangText } = useLang();

    const containRef = useRef(null)
    const childBoxRef = useRef(null)

    const [isOver, setIsOver] = useState(false)
    const [overList, setOverList] = useState([])
    const [isHover, setIsHover] = useState(false)

    const handleResize = () => {
        checkTagView()
    };

    const checkTagView = () => {
        // console.log("after render!")
        // console.log(childBoxRef.current?.clientWidth)
        // console.log(childBoxRef.current?.scrollWidth)

        let childList = childBoxRef.current.children
        for (let child of childList) {
            child.style.setProperty("display", "block")
        }

        if (childBoxRef.current?.clientWidth < childBoxRef.current?.scrollWidth) {
            let childList = childBoxRef.current.children
            if (childList.length > 0) {
                let totalWidth = 0;
                const ovList = []

                for (let child of childList) {
                    // console.log("childWidth", child.clientWidth);
                    if (child.className != "dot_box") {
                        totalWidth += (child.clientWidth + 4)
                        if (totalWidth > (childBoxRef.current?.clientWidth - 33)) {
                            child.style.setProperty("display", "none")
                            ovList.push(child.textContent)
                        } else {
                            child.style.setProperty("display", "block")
                        }
                    }
                }
                setOverList(ovList)
            }
            setIsOver(true)
        }
        else {
            setIsOver(false)
        }
    }

    useEffect(() => {
        checkTagView()

        window.addEventListener("resize", handleResize);
        return () => {
            // cleanup
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return <div
        ref={containRef}
        className={`tag_box ${className ? className : ""}`} style={{
            ...style,
            // overflow: "hidden"
        }}
    >
        <div
            ref={childBoxRef}
            className="tag_child_box"
        >
            {list.map((v, i) => {
                return <div className="item">
                    {/* {v} */}
                    {String(v).indexOf("option_") >= 0 ? getLang({ key: v }) : v}
                </div>
            })}
            {isOver && <div
                className="dot_box"
                onMouseOver={() => {
                    setIsHover(true)
                }}
                onMouseLeave={() => {
                    setIsHover(false)
                }}
            >
                ...
                {/* {isHover && <div className="more_info">
                    {overList.length > 0 && overList.map((v, i) => {
                        if (i == 0)
                            return v
                        else
                            return " / " + v
                    })}
                </div>} */}
            </div>}
        </div>
    </div >
}